// extracted by mini-css-extract-plugin
module.exports = {"yc-radio":"yc-radio--2ynnc","label":"label--7xfaO","list":"list--25Vi7","item":"item--1AQAe","active":"active--2AFUo","toggle":"toggle--1K73s"};